module.exports = {
  draftsList: 'Drafts List',
  closedList: 'Closed List',
  header: {
    titleTiles: 'Horizontal Tiles',
    titleExplorer: 'Vertical Tiles',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: 'No',
      cardName: 'CARD NAME',
      template: 'TEMPLATE',
      status: 'STATUS',
      action: 'ACTION',
      showHide: 'SHOW/HIDE',
      countries: 'COUNTRIES',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      activate: 'Activate',
      deactivate: 'Deactivate',
      show: 'Show',
      hide: 'Hide',
      close: 'Close',
    },
  },
  modal: {
    titleCreate: 'Create Card',
    chooseCard: 'Choose card template',
    template: 'Template',
    justIn: 'Just In',
    insights: 'Insights',
    handicap: 'Handicap',
    scores: 'Scores',
    target: 'Target',
    upToDate: 'Up to date',
    promotion: 'Promotion',
  },
  form: {
    cardName: 'Card Name',
    labelOfCard: 'Label',
    labelOfCardPlaceholder: 'Card label',
    image: 'Image',
    imagePlaceholder: 'Upload or enter link',
    subTitle: 'Subtitle',
    subTitlePlaceholder: 'Description',
    countries: 'Country',
    title: 'Title',
    titlePlaceholder: 'Card title',
    description: 'Description',
    descriptionTitle: 'Title',
    descriptionPlaceholder: 'Card description',
    score: 'Score',
    scoreAfterPlaceholder: 'After',
    scoreBeforePlaceholder: 'Before',
    button: 'Button',
    buttonLink: 'Button link',
    link: 'Link',
    buttonText: 'Button text',
    productId: 'ECom Product ID',
    productIdPlaceholder: 'ECom Product ID',
    contentType: 'Content Type',
    contentId: 'Content ID',
    contentFormat: 'Content Format',
    content: 'CMS Content',
    type: 'Type',
    homeTypePlaceholder: 'Type',
    category: 'Category',
    featureDeepLink: 'Feature App Deep Link',
    colorOpacity: 'Background Opacity',
    textColor: 'Text Color',
    buttonAlign: 'Button Align',
    textAlign: 'Text Align',
    deepLink: 'Deep Link',
  },
  btnCreateCard: 'Create Card',
  btnUpdateCard: 'Update Card',
  message: {
    createHomeTilesSuccess: 'Horizontal Tiles successfully created.',
    updateHomeTilesSuccess: 'Horizontal Tiles successfully updated.',
    createHomeTilesError: 'Failed to create Horizontal Tiles.',
    updateHomeTilesError: 'Failed to update Horizontal Tiles.',
    createHomeExplorerSuccess: 'Vertical Tiles successfully created.',
    updateHomeExplorerSuccess: 'Vertical Tiles successfully updated.',
    createHomeExplorerError: 'Failed to create Vertical Tiles.',
    updateHomeExplorerError: 'Failed to update Vertical Tiles.',
    productEcomError: 'Please select another product to display the tile content.',
  },
  validate: {
    nameBlank: 'Please input Card Name.',
    countryBlank: 'Please select Country',
    descriptionBlank: 'Please input Description.',
    labelBlank: 'Please input Label.',
    titleBlank: 'Please input Title.',
    imageBlank: 'Please upload a image.',
    buttonText: 'Please input Button text.',
    buttonLink: 'Please input Button link.',
    linkBlank: 'Please input link.',
    homeTypeBank: 'Please input Type.',
  },
  popup: {
    title: 'Confirm',
    okBtn: 'Yes',
    cancelBtn: 'No',
    delete: 'Are you sure you want to delete this card?',
    activate: 'Are you sure you want to activate this card?',
    deactivate: 'Are you sure you want to deactivate this card?',
    show: 'Are you sure you want to show this card?',
    hide: 'Are you sure you want to hide this card?',
    close: 'Are you sure you want to close this card?',
    confirmPassword: 'Please input your password to confirm.',
    edit: 'Are you sure you want to edit this card?',
  },
};
